import { Modules } from '../../../util/modules'
import { RouteConfig } from 'vue-router'
import { estimatesRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../../auth'
// Estimates App
const EstimatesDashboardApp = () => import('@/pmd/pages/payments/EstimatesDashboard.vue')
const EstimatesEditorApp = () => import('@/pmd/pages/payments/EstimatesEditor.vue')
const EstimatesTemplateApp = () => import('@/pmd/pages/payments/EstimatesTemplate.vue')

export const estimatesRoutes: RouteConfig[] = [
  {
    path: 'payments/v2/estimates/edit/:id',
    name: estimatesRouteNames.estimatesEditor,
    component: EstimatesEditorApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
    children: [],
  },
  {
    path: 'payments/v2/estimates/templates/edit/:id',
    name: estimatesRouteNames.estimatesTemplateEditor,
    component: EstimatesTemplateApp,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideSideBar: true,
      hideTopBar: true,
      translations: [Modules.Payments],
    },
    children: [],
  },
  {
    path: 'payments/v2/estimates',
    name: estimatesRouteNames.listEstimates,
    component: EstimatesDashboardApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
]
